// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';

const { formatStake, isValidStake } = BasketUtils;

/**
 * Return the nextState corresponding to the BASKET_STAKE_CHANGE action
 *
 * @param  {Object} state  The actual state.
 * @param  {Object} action The action to reduce.
 * @return {Object}        Return the new state.
 */
const basketStakeChange = (state, action) => {
  const { status, stake } = state;
  const { stake: nextStake, force } = action.payload;
  /* force is used only in case we receive an amount from the api response */
  if (status !== BasketStatuses.PENDING || force) {
    const formatedStake = formatStake(nextStake);
    if (formatedStake !== stake) {
      if (isValidStake(formatedStake)) {
        const nextItems = Object.keys(state.items).reduce(
          (acc, oddId) => ({
            ...acc,
            [oddId]: {
              ...state.items[oddId],
              stake: formatedStake,
            },
          }),
          {},
        );

        return {
          ...state,
          stake: formatedStake,
          items: nextItems,
        };
      }
    }
  }
  return state;
};

export default basketStakeChange;
